import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  ref: "question"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "0.5rem",
    "background-color": "#f4f4f4"
  }
}, null, -1);

const _hoisted_3 = {
  class: "one-nr"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "decs"
};
const _hoisted_6 = {
  class: "one-nr"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "decs"
};
const _hoisted_9 = {
  class: "one-nr"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "decs-btn"
};
const _hoisted_14 = {
  class: "one-step"
};
const _hoisted_15 = {
  key: 0,
  class: "btngroup"
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-top",
  style: {
    "font-size": "22px"
  }
}, null, -1);

const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  class: "chat-btn"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "el-icon-chat-dot-round",
  style: {
    "font-size": "16px",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "dian"
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoblieTicket = _resolveComponent("MoblieTicket");

  const _component_MoblieStepType = _resolveComponent("MoblieStepType");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_MoblieTicket, {
    show: _ctx.ticket.show,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => _ctx.ticket.show = $event),
    questionType: _ctx.ticket.questionType,
    question: _ctx.ticket.question,
    questionRecord: _ctx.ticket.questionRecord
  }, null, 8, ["show", "questionType", "question", "questionRecord"]), _ctx.questionTemp ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx._t('title')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.questionTemp.title), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx._t('linkItem')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getItemsName(_ctx.questionTemp.item)), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx._t('description')), 1), _createElementVNode("div", {
    class: "decs",
    innerHTML: _ctx.questionTemp.description
  }, null, 8, _hoisted_11)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepTemp, (_questionStep, _questionStepIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "one-step",
      key: _questionStepIndex
    }, [_questionStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx._t("step")) + _toDisplayString(Number(_questionStepIndex) + 1), 1), _createElementVNode("div", _hoisted_13, [_createVNode(_component_MoblieStepType, {
      question: _ctx.questionTemp,
      step: _questionStep,
      disabled: _questionStepIndex != _ctx.stepTemp.length - 1 || _ctx.stepEnd
    }, null, 8, ["question", "step", "disabled"])])], 64)) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", _hoisted_14, [_ctx.stepEnd ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.btnClass(_ctx.solvedDisabled || _ctx.unsolvedDisabled, _ctx.unsolvedDisabled), "btn"]),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.clickChatNow(_ctx.questionTemp))
  }, _toDisplayString(_ctx._t("unsolvedAndChatNow")), 3), _createElementVNode("div", {
    class: _normalizeClass([_ctx.btnClass(_ctx.solvedDisabled || _ctx.unsolvedDisabled, _ctx.solvedDisabled), "btn"]),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.clickSolved(_ctx.questionTemp))
  }, _toDisplayString(_ctx._t("solved")), 3), _ctx.stepTemp.length > 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["btn", _ctx.btnClass()]),
    onClick: _cache[3] || (_cache[3] = (...args) => _ctx.clickBackPreStep && _ctx.clickBackPreStep(...args))
  }, _hoisted_17, 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.clickChatNow(_ctx.questionTemp))
  }, [_hoisted_19, _createTextVNode(" " + _toDisplayString(_ctx._t("needHelp")), 1)])])])], 512)) : _createCommentVNode("", true)], 64);
}